import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface EnrollmentContextState {
  enrollmentContext: string;
  previousEnrollmentContext: string;
  enrollmentOrgPlanId: number;
  enrollmentOrgLifeEventId: number;
  hasQuestionnaire: boolean;
  enrollmentOrgPlanYearId?: number;
}

const initialState: EnrollmentContextState = {
  enrollmentContext: '',
  previousEnrollmentContext: '',
  enrollmentOrgPlanId: 0,
  enrollmentOrgLifeEventId: 0,
  hasQuestionnaire: false,
  enrollmentOrgPlanYearId: 0,
};

const enrollmentContextSlice = createSlice({
  name: 'enrollmentContext',
  initialState,
  reducers: {
    setEnrollmentContext: (state, { payload }: PayloadAction<string>) => {
      state.enrollmentContext = payload;
      state.previousEnrollmentContext = payload;
      localStorage.setItem('enrollmentContext', payload);
    },
    setEnrollmentOrgPlanYearId: (state, { payload }: PayloadAction<number>) => {
      state.enrollmentOrgPlanYearId = payload;
      localStorage.setItem('enrollmentSelectedYear', payload);
    },
    setEnrollmentOrgPlanId: (state, { payload }: PayloadAction<number>) => {
      state.enrollmentOrgPlanId = payload;
    },
    setEnrollmentOrgLifeEventId: (
      state,
      { payload }: PayloadAction<number>
    ) => {
      state.enrollmentOrgLifeEventId = payload;
    },
    setHasQuestionnaire: (state, { payload }: PayloadAction<boolean>) => {
      state.hasQuestionnaire = payload;
    },
  },
});

const { reducer, actions } = enrollmentContextSlice;

export const {
  setEnrollmentContext,
  setEnrollmentOrgLifeEventId,
  setEnrollmentOrgPlanId,
  setEnrollmentOrgPlanYearId,
  setHasQuestionnaire,
} = actions;

export const enrollmentContextReducer = reducer;
